<template>
	<div v-if="dataLoaded">
		<v-toolbar color="blue lighten-1" class="white--text">
			<v-icon color="white">person</v-icon>
			<v-toolbar-title>Użytkownicy konkursu</v-toolbar-title>
		</v-toolbar>
		<div class="ma-4">
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Główny sekretarz</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					<div v-if="users.mainSecretaries.length === 0">-</div>
					<div v-else>
						{{users.mainSecretaries.map(item => item.fullName).join(", ")}}
					</div>
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Główny przewodniczący</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					<div v-if="users.mainLeaders.length === 0">-</div>
					<div v-else>
						{{users.mainLeaders.map(item => item.fullName).join(", ")}}
					</div>
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader>
						<strong>Pozostali użytkownicy</strong>
						<v-btn flat icon class="ml-2" @click="handleListExpansion">
							<v-icon>{{getUserListIcon}}</v-icon>
						</v-btn>
					</v-subheader>
				</v-flex>
				<v-flex xs6>
					<i v-if="!showAllContestUsers">Lista ukryta</i>
					<v-expand-transition v-if="showAllContestUsers">
						<v-list two-line>
							<template v-for="user in users.otherUsers">
								<v-list-tile :key="user.id" avatar class="list-item">
									<v-list-tile-avatar>
										<v-icon>person</v-icon>
									</v-list-tile-avatar>
									<v-list-tile-content>
										<v-list-tile-title v-html="user.fullName"
											style="font-size: 14px"></v-list-tile-title>
										<v-list-tile-sub-title v-html="user.email"></v-list-tile-sub-title>
										<v-list-tile-action-text
											v-html="'Rola: ' + getRoleName(user.contestRole)"></v-list-tile-action-text>
									</v-list-tile-content>
								</v-list-tile>
							</template>
						</v-list>
					</v-expand-transition>
				</v-flex>
			</v-layout>
		</div>
	</div>
</template>

<script>
	import {PublicContest} from "../../../../api/generated/PublicContest";

	export default {
		name: "ContestSummaryUsersView",

		data () {
			return {
				users: [],
				showAllContestUsers: false,
				dataLoaded: false
			};
		},

		created () {
			this.getContestSummaryUsersData();
		},

		computed: {
			getUserListIcon () {
				return this.showAllContestUsers ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
			}
		},

		methods: {
			handleListExpansion () {
				this.showAllContestUsers = !this.showAllContestUsers;
			},

			getContestSummaryUsersData () {
				PublicContest.getSummaryUsersData(this, this.$route.params.id, successResponse => {
						this.users = successResponse;
						this.dataLoaded = true;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować użytkowników konkursu", errorResponse);
					});
			},

			getRoleName (contestRole) {
				switch (contestRole) {
					case 'MAIN_LEADER':
						return "przewodniczący komisji (główny)";
					case 'LEADER':
						return "przewodniczący komisji";
					case 'MAIN_SECRETARY':
						return "sekretarz konkursu (główny)";
					case 'SECRETARY':
						return "sekretarz konkursu";
					case 'COMMITTEE_USER':
						return "członek komisji";
					default:
						return "brak";
				}
			}
		}
	};
</script>

<style scoped>

</style>